<template>
  <div id="app">
    <div id="home">
      <el-container class="menu">
        <!-- header -->
        <!--<el-header class="header">-->
          <!--<HeadBar></HeadBar>-->
        <!--</el-header>-->
        <el-container>
          <!-- 侧边导航 -->
          <el-aside v-if="$route.meta.keepAlive">
            <NavBar></NavBar>
          </el-aside>
          <!-- 跳转展示的区域 -->
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>
<script>
  import HeadBar from './components/HeadBar.vue';
  import NavBar from './components/NavBar.vue';
  export default{
    name: 'App',
    components: {
      HeadBar: HeadBar,
      NavBar: NavBar
    },
    mounted() {

    }
  }
</script>

<style>
  html,body{
    width:100%;
    height:100%;
    margin: 0;
    padding: 0;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    text-align: center;
    color: #2ba5f6;
  }
  .el-form-item.is-success .el-input__inner, .el-form-item.is-success .el-input__inner:focus, .el-form-item.is-success .el-textarea__inner, .el-form-item.is-success .el-textarea__inner:focus {
    border-color:#2BA5F6;
  }
</style>
<style scoped>
  #home{
    background: #f2f2f2;
    width: 100%;
    height: 100%;
  }
  .menu {
    width: 100%;
    height: 100%;
  }
  .el-aside {
    background-color: #424244;
    color: #fff;
    text-align: center;
    line-height: 200px;
    width:206px !important;
  }
  .el-main {
    background:#fff;
    border-radius: 5px;
    position:relative;
    padding:0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue